import { Input, type InputProps, Label } from "@exopengithub/exokit";
import { useId } from "react";
import { useTranslation } from "react-i18next";

interface InputFieldProps extends Omit<InputProps, "id"> {
	label?: string | undefined;
	labelOptional?: boolean | undefined;
}

export function InputField({
	label,
	labelOptional,
	clearAriaLabel,
	dismissErrorAriaLabel,
	showPasswordAriaLabel,
	hidePasswordAriaLabel,
	...props
}: InputFieldProps) {
	const id = useId();
	const { t } = useTranslation();
	return (
		<div>
			{label && (
				<Label
					htmlFor={id}
					optional={labelOptional ?? false}
					optionalLabel={t("(optional)")}
				>
					{label}
				</Label>
			)}
			<Input
				{...props}
				id={id}
				clearAriaLabel={clearAriaLabel ?? t("Clear")}
				dismissErrorAriaLabel={dismissErrorAriaLabel ?? t("Dismiss error")}
				showPasswordAriaLabel={showPasswordAriaLabel ?? t("Show password")}
				hidePasswordAriaLabel={hidePasswordAriaLabel ?? t("Hide password")}
			/>
		</div>
	);
}
